import { Gift } from "lucide-react";

export const InviteBanner = ({ invite, onClear }) => (
  <div className="mb-8 flex flex-wrap items-start justify-between gap-4 rounded-lg border-2 border-gold bg-[#FFFBF0] p-5" role="status" data-testid="invite-banner">
    <div className="flex items-start gap-3">
      <Gift className="mt-0.5 shrink-0 text-ciarb" size={22} aria-hidden="true" />
      <div>
        <p className="font-semibold text-navy" data-testid="invite-banner-label">{invite.label}</p>
        <p className="text-sm text-[#4A5568]">
          Invitation verified{invite.sponsor_name ? ` (courtesy of ${invite.sponsor_name})` : ""}. No payment is required.
          {invite.email_locked && " Please register with the email address the invitation was sent to."}
        </p>
      </div>
    </div>
    <button type="button" className="text-sm font-semibold text-navy underline underline-offset-4" onClick={onClear} data-testid="invite-clear-btn">Register without invitation</button>
  </div>
);

export const InviteError = ({ message }) => (
  <p role="alert" className="mb-8 rounded-lg border border-red-200 bg-red-50 p-4 text-sm font-semibold text-red-800" data-testid="invite-error">{message}</p>
);
